import { render, staticRenderFns } from "./table-gongyi.vue?vue&type=template&id=27a9d408&scoped=true"
import script from "./table-gongyi.vue?vue&type=script&lang=js"
export * from "./table-gongyi.vue?vue&type=script&lang=js"
import style0 from "./table-gongyi.vue?vue&type=style&index=0&id=27a9d408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9d408",
  null
  
)

export default component.exports